import { useEffect } from "react";

import { useUser } from "hooks/user/useUser";
import { setSentryUserContext } from "utils/sentryErrorTracking";

/**
 * Hook that automatically sets Sentry user context whenever the user changes
 * This should be called once at the top level of the application
 */
export function useSentryUserContext(): void {
    const user = useUser();

    useEffect(() => {
        // Update Sentry user context whenever the user changes
        setSentryUserContext(user);
    }, [user, user?.id, user?.userprofile?.customer_type, user?.tier]);
}

